import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setHostPickerActiveReducer = (state: EditorState, action: PayloadAction<boolean>) => {
  state.hostPickerActive = action.payload;
};

export default setHostPickerActiveReducer;
